<template>
  <div id="app">
    <v-container>
      <Header />
      <div v-if="clientAccessLoginPanel">
        <v-row>
          <v-col :cols="7">
            <v-row justify="center" align="center">
              <v-col>
                <img src="/assets/img/fgraphicHeart.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicApple.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicSteth.png" />
              </v-col>
            </v-row>
            <v-row justify="center" align="center">
              <v-col>
                <img src="/assets/img/fgraphicSpine.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicMind.png" />
              </v-col>
              <v-col>
                <img src="/assets/img/fgraphicWalk.png" />
              </v-col>
            </v-row>
          </v-col>

          <v-col :cols="5">
            <v-card class="mx-auto entercodebox" flat color="transparent">
              <v-card-text>
                <p class="display-1">Enter Password</p>

                <v-alert
                  type="error"
                  class="mt-5"
                  v-if="showPasswordInvalidMessage"
                  dense
                  >Password is incorrect.</v-alert
                >

                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  name="input-10-2"
                  label="Client area password"
                  value="wqfasds"
                  class="entercodeboxinput"
                  outlined
                  @click:append="showPassword = !showPassword"
                ></v-text-field>

                <v-btn
                  @click="submitPassword"
                  depressed
                  large
                  color="primary"
                  block
                  class="hp--btn"
                  >SUBMIT</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-if="clientAccessLoginErrorPanel">
        <v-card class="mx-auto" max-width="400">
          <v-toolbar flat>
            <v-toolbar-title class="black--text">Oops...</v-toolbar-title>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-text>
            <p class="darkgrey--text text-center">We can't find your event!</p>
            <p class="text-center ma-2">
              If you need to get in touch,
              <a href="#" style="color: green"> click here. </a>
            </p>
          </v-card-text>
        </v-card>
      </div>
      <EventBooking :eventData="events" v-if="events !== null" />
      <Footer />
    </v-container>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EventBooking from "../components/BookingsByEvent.vue";
import { API } from "aws-amplify";
import * as queries from "./../graphql/queries";

export default {
  components: {
    Header,
    Footer,
    EventBooking,
  },
  data() {
    return {
      clientAccessLoginPanel: false,
      clientAccessLoginErrorPanel: false,
      password: "",
      showPasswordInvalidMessage: false,
      showPassword: false,
      events: null,
      nextToken: null,
    };
  },
  async created() {
    let events = await this.nextRecord();

    while (this.nextToken !== null) {
      let nextEvents = await this.nextRecord();
      events.push(...nextEvents);
    }
    if (events) {
      this.clientAccessLoginPanel = true;
    } else {
      this.clientAccessLoginErrorPanel = true;
    }
  },
  methods: {
    async nextRecord() {
      const listEvents = /* GraphQL */ `
        query ListEvents(
          $filter: ModelEventFilterInput
          $limit: Int
          $nextToken: String
        ) {
          listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
              id
            }
            nextToken
          }
        }
      `;

      const event = await API.graphql({
        query: listEvents,
        variables: {
          filter: { clientAccess: { contains: this.$route.params.eventId } },
          nextToken: this.nextToken,
        },
        authMode: "API_KEY",
      });
      this.nextToken = event.data.listEvents.nextToken;
      return event.data.listEvents.items;
    },
    async submitPassword() {
      const isClientPassword = /* GraphQL */ `
        query IsClientPassword($id: ID!, $clientPassword: String!) {
          isClientPassword(id: $id, clientPassword: $clientPassword) {
            id
            clientPassword
            description
          }
        }
      `;

      let isAuthenticated = false;
      try {
        isAuthenticated = await API.graphql({
          query: isClientPassword,
          variables: {
            id: this.$route.params.eventId,
            clientPassword: this.password,
          },
          authMode: "API_KEY",
        });

        if (isAuthenticated.id) {
          this.getEventDetails();
        }
      } catch (error) {
        this.clientAccessLoginPanel = true;
        this.clientAccessLoginErrorPanel = false;
        this.showPasswordInvalidMessage = true;
      }

      if (isAuthenticated !== false) {
        this.getEventDetails();
      }
    },
    async getEventDetails() {
      const listEvents = /* GraphQL */ `
        query ListEvents(
          $filter: ModelEventFilterInput
          $limit: Int
          $nextToken: String
        ) {
          listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
            items {
              eventCompany {
                id
                name
              }
              id
              name
              code
              status
              type
              iCalendar
              eventLocation(filter: { isDeleted: { eq: 0 } }) {
                items {
                  id
                  addressLine1
                  postcode
                  town
                  createdAt
                  eventSlotGroup(filter: { isDeleted: { eq: 0 } }) {
                    items {
                      id
                      room
                      createdAt
                      date
                      capacity
                      eventSlot(limit: 1000, filter: { isDeleted: { eq: 0 } }) {
                        items {
                          id
                          length
                          time
                          type
                          booked
                          eventBooking(
                            limit: 1000
                            filter: { isDeleted: { eq: 0 } }
                          ) {
                            items {
                              id
                              firstname
                              lastname
                              email
                              dob
                              mobile
                              isDeleted
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              eventCollectUserData {
                items {
                  id
                  label
                  validation
                  fieldType
                  createdAt
                  isDeleted
                  eventCollectUserDataOptions {
                    items {
                      id
                      options
                    }
                  }
                }
              }
            }
            nextToken
          }
        }
      `;

      const events = await API.graphql({
        query: listEvents,
        variables: {
          limit: 1000,
          filter: {
            clientAccess: { contains: this.$route.params.eventId },
            isDeleted: { eq: 0 },
          },
        },
        authMode: "API_KEY",
      });

      this.clientAccessLoginPanel = false;
      this.clientAccessLoginErrorPanel = false;

      this.events = [];
      this.events = events.data.listEvents.items;
    },
  },
};
</script>